/**
 * SCSS IMPORT FILE
 * this file is just for scss imports which will create css classes
 */
import '@swisslife/shared-ui/src/base/bootstrap/css/bootstrap';
import './backdrop.scss';
import './modifier/white.scss';
import './modifier/transition-group.scss';
